import type { ReactNode } from 'react';

/**
 * The foot of a form in a sheet: its buttons, and a refusal said right above them — where the eye
 * is when « Enregistrer » is pressed, never scrolled out of view (audit du 13/10/2026). Stuck to the
 * panel's bottom edge: `-bottom-10` cancels the scroll area's `pb-10`, inside which a sticky element
 * would otherwise float, the content showing under it.
 */
export function SheetFormFooter({ error, children }: { error: string | null; children: ReactNode }) {
  return (
    <div className="sticky -bottom-10 z-10 -mx-6 mt-2 border-t border-desk-line bg-desk-bg px-6 py-3 sm:-mx-8 sm:px-8">
      {error && (
        <p role="alert" className="mb-2.5 rounded-[10px] bg-red-50 px-3 py-2 text-sm text-red-700 dark:bg-red-950/40 dark:text-red-300">
          Pas enregistré : {error}
        </p>
      )}
      <div className="flex justify-end gap-2">{children}</div>
    </div>
  );
}
